import React from "react";
import { fmtNumber } from "../utils/helpers";

function ChartRow({ rank, metro, latest, score, showChart, allDates, latestDate, extraCell, precomputedPriceYoY, showMapInline = true, addMapCell = false, areaType, setSelectedMetro, setView, type }) {

  const renderDelta = (value, lowerIsBetter = false) => {
    // General rule: treat 0 values as missing data (0% change is not meaningful)
    if (value == null || value === 0) return <span style={{ marginLeft: 6, color: "#666" }}>-</span>;
    const isUp = value > 0;
    const improved = lowerIsBetter ? !isUp : isUp;
    const arrow = isUp ? "▲" : "▼";
    const color = improved ? "#118a00" : "#c22727";
    const percentage = Math.abs(value * 100);
    
    return (
      <span style={{ color, marginLeft: 6 }}>
        {arrow} {percentage.toFixed(1)}%
      </span>
    );
  };
  
  const displayPriceYoY = Number.isFinite(precomputedPriceYoY) ? precomputedPriceYoY : latest?.Price_YoY_delta;
  

  // Determine the correct display name based on area type
  const getDisplayName = () => {
    if (areaType === "City" && latest?.City) {
      // For City level, show just the city name, not the metro area name
      return latest.City;
    } else if (areaType === "County" && latest?.CountyName) {
      // For County level, show the county name
      return latest.CountyName;
    } else if (areaType === "Zipcode" && latest?.Zipcode) {
      // For Zipcode level, show the zipcode
      return latest.Zipcode;
    } else if (areaType === "Neighborhood" && latest?.Neighborhood) {
      // For Neighborhood level, show the neighborhood name
      return latest.Neighborhood;
    }
    // Default to the metro prop (for Metro and State levels)
    return metro;
  };

  const displayName = getDisplayName();

  return (
    <tr>
      <td>{rank}</td>
      <td>{displayName}</td>
      <td>
        {latest?.Price != null ? fmtNumber(latest.Price, 0) : "-"}
        {renderDelta(latest?.Price_delta, false)}
      </td>
      <td className="hide-sm">
        {renderDelta(displayPriceYoY, false)}
      </td>
      <td className="hide-sm">
        {latest?.Rent != null ? fmtNumber(latest.Rent, 0) : "-"}
        {renderDelta(latest?.Rent_delta, false)}
      </td>
      <td className="hide-sm">
        {latest?.Inventory != null ? fmtNumber(latest.Inventory, 0) : "-"}
        {renderDelta(latest?.Inventory_delta, true)}
      </td>
      <td className="hide-sm">
        {latest?.Days != null ? fmtNumber(latest.Days, 0) : "-"}
        {renderDelta(latest?.DOM_delta, true)}
      </td>
      {/* Forecasts (fractions → percents) */}
      <td className="hide-sm">{Number.isFinite(latest?.f1m) ? `${Number(latest.f1m).toFixed(1)}%` : '-'}</td>
      <td className="hide-sm">{Number.isFinite(latest?.f3m) ? `${Number(latest.f3m).toFixed(1)}%` : '-'}</td>
      <td className="hide-sm">{Number.isFinite(latest?.f12m) ? `${Number(latest.f12m).toFixed(1)}%` : '-'}</td>
      <td className="hide-sm">{Number.isFinite(score) ? score.toFixed(2) : "-"}</td>
      <td>
        <button 
          className="btn" 
          title="Open chart" 
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            console.log("[CHART_ROW] Data button clicked for:", metro, "type:", type);
            if (metro && setSelectedMetro && setView) {
              console.log("[CHART_ROW] Setting selectedMetro to:", metro);
              setSelectedMetro(metro);
              // Set correct view for snapshot
              const snapshotView = "performance-snapshot";
              console.log("[CHART_ROW] Setting view to:", snapshotView);
              setView(snapshotView);
              console.log("[CHART_ROW] View and selectedMetro set successfully");
            } else {
              console.log("[CHART_ROW] Missing required functions:", { setSelectedMetro: !!setSelectedMetro, setView: !!setView });
            }
          }}
        >
          <span role="img" aria-label="Open chart">📈</span>
        </button>
        {showMapInline ? (
          <a
            className="btn"
            title="Open in Google Maps"
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(String(metro))}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginLeft: 6 }}
          >
            <span role="img" aria-label="Open map">🗺️</span>
          </a>
        ) : null}
      </td>
      {addMapCell ? (
        <td>
          <a
            className="btn"
            title="Open in Google Maps"
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(String(metro))}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            🗺️
          </a>
        </td>
      ) : null}
      {extraCell !== undefined ? (
        <td>
          {extraCell}
        </td>
      ) : null}
    </tr>
  );
}

export default ChartRow;
